import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { ButtonPrimary } from "../../../ui/buttons";

const CloseNPModal = ({ toggle, isOpen, estado, handleAnularCancelar, setShowBackupFileModal }) => {
  const handleClickAnular = () => {
    setShowBackupFileModal(true);
    toggle();
  };

  const handleClickPreCancelar = () => {
    handleAnularCancelar(estado);
    toggle();
  };
  let estadoClose;
  if (estado === 6) {
    estadoClose = "Anular";
  }
  if (estado === 9) {
    estadoClose = "Pre Cancelar";
  }

  return (
    <div>
      <Modal isOpen={isOpen}>
        <ModalBody>
          <div className="px-4 pt-4">
            <p style={{ fontSize: "18px", fontFamily: "Nunito" }}>
              ¿Esta seguro de <span className="font-weight-bold">{estadoClose}</span> ? Luego de esta acción no podrá volver a editar la nota de pedido
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="border-0">
          <Button color="btn-secondary" onClick={toggle} type="button">
            Cancelar
          </Button>
          {estado === 9 ? (
            <ButtonPrimary onClick={handleClickPreCancelar} type="button">
              Continuar
            </ButtonPrimary>
          ) : (
            <ButtonPrimary onClick={handleClickAnular} type="button">
              Confirmar
            </ButtonPrimary>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default CloseNPModal;
